
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { ImageWithDimensions } from '@/utils/models';
import { DataService } from '@/service/DataService';
import { uploadFile } from '@/utils/functions';

@Component({ components: { Popup } })
export default class ImagePreviewPopup extends Vue {
  @Prop() private dataService!: DataService;
  @Prop() private subId!: string;
  @Prop() private image!: ImageWithDimensions | null;

  @Emit()
  close() {}

  url: string | null = null;
  mounted() {
    if (this.image?.file) {
      this.url = URL.createObjectURL(this.image.file);
    }
  }
  beforeDestroy() {
    if (this.url) {
      URL.revokeObjectURL(this.url);
    }
  }

  async uploadImageToServer(): Promise<any> {
    if (this.image?.file) {
      const url = await uploadFile(this.dataService, 'image', this.image.file);
      this.dataService.emitUploadImage(url, this.image.width, this.image.height, this.subId);
      this.hidePopup();
    }
  }

  hidePopup(): void {
    this.close();
  }
}
